export const SERVER_URL =
  process.env.REACT_APP_SERVER_URL ||
  'https://api-dot-guardian-center-dev.uc.r.appspot.com/';
export const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_REDIRECT_URL = process.env.REACT_APP_GOOGLE_REDIRECT_URL;